export default __webpack_public_path__ + "static/media/city.cac4a191.mp3";